import { baseResources, baseResourceActions } from "routes/enum";

const { KB_CANNED_RESPONSE } = baseResources;
const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

export const CANNED_RESPONSE_READ_PERMISSION = [`${READ}_${KB_CANNED_RESPONSE}`];
export const CANNED_RESPONSE_CREATE_PERMISSION = [
    `${CREATE}_${KB_CANNED_RESPONSE}`,
];
export const CANNED_RESPONSE_UPDATE_PERMISSION = [
    `${UPDATE}_${KB_CANNED_RESPONSE}`,
];
export const CANNED_RESPONSE_DELETE_PERMISSION = [
    `${DELETE}_${KB_CANNED_RESPONSE}`,
];
